module.exports = __webpack_public_path__ + "img/webview.c5c06161.png";